import { useMutation } from "@apollo/client";
import { updateOrangeDotStatus } from "GraphQL/mutation/targetReview";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { getUserId } from "src/utils/index";
import {
  checkinDetailSelector,
  learningResponseSelector,
  surveyResponseSelector,
} from "Recoil/Checkins/selector";
import { useParams } from "react-router";

export const updateOrangeDotHighlightStatus = () => {
  const [updateOrangeDotRatingStatus] = useMutation(updateOrangeDotStatus);
  const [learningResponseData, setLearningResponseData] = useRecoilState(
    learningResponseSelector
  );
  const setSurveyResponseData = useSetRecoilState(surveyResponseSelector);
  const { checkInType } = useRecoilValue(checkinDetailSelector);
  const { id: targetId, checkinId } = useParams();
  const userId = getUserId();

  const updateIsNewResponseHighlight = (colProps) => {
    try {
      if (colProps?.dataItem?.isNewResponseHighlight) {
        updateOrangeDotRatingStatus({
          variables: {
            input: {
              targetid: targetId,
              userid: [colProps?.dataItem?.userid],
              checkinId: [checkinId],
              isNewHighlighted: false,
              checkinType: checkInType?.toLowerCase(),
            },
          },
        })
          .then((res) => {
            setLearningResponseData((list) => {
              let currentIndex = list?.findIndex(
                (res) => res?.id === colProps?.dataItem?.id
              );
              const learningListData = [...list];
              learningListData[currentIndex] = {
                ...list[currentIndex],
                isNewResponseHighlight: false,
                isNewRowHighlight: false,
              };
              return learningListData;
            });
          })

          .catch((error) => {
            console.log(error);
          });
      }
      // Update parent state based on API response
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  const updateIsNewRowHighlight = (colProps) => {
    try {
      if (colProps?.dataItem?.isNewRowHighlight) {
        updateOrangeDotRatingStatus({
          variables: {
            input: {
              targetid: targetId,
              userid: [
                ["SURVEY", "REQUESTFEEDBACK"].includes(checkInType)
                  ? colProps?.dataItem?.id
                  : colProps?.dataItem?.userid,
              ],
              checkinId: [checkinId],
              isNewHighlighted: true,
              checkinType: checkInType?.toLowerCase(),
            },
          },
        })
          .then(() => {
            if (["SURVEY", "REQUESTFEEDBACK"].includes(checkInType)) {
              setSurveyResponseData((list) => {
                let currentIndex = list?.findIndex(
                  (res) => res?.id === colProps?.dataItem?.id
                );
                const surveyListData = [...list];
                surveyListData[currentIndex] = {
                  ...list[currentIndex],
                  isNewRowHighlight: false,
                };
                return surveyListData;
              });
            } else {
              setLearningResponseData((list) => {
                let currentIndex = list?.findIndex(
                  (res) => res?.id === colProps?.dataItem?.id
                );
                const learningListData = [...list];
                learningListData[currentIndex] = {
                  ...list[currentIndex],
                  isNewRowHighlight: false,
                };
                return learningListData;
              });
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }

      // Update parent state based on API response
    } catch (error) {
      console.error("API Error:", error);
    }
  };
  return { updateIsNewResponseHighlight, updateIsNewRowHighlight };
};
